<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-operate>
				<c-button icon="add" @click="navigateTo('/transact/bidding/create', true)">新建中标项目</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="项目编号"
					name="code"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="项目名称"
					name="name"
					width="250"
				></c-table-column>
				
				<c-table-column
					label="监理单位"
					width="250"
				>
					<template v-slot="{data}">
						<span v-if="data.jldw_name">{{data.jldw_name}}</span>
						<span v-else style="color: #E63633;">未绑定</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="项目人员"
					width="90"
				>
					<template v-slot="{data}">
						<span v-if="!data.jldw_name" style="color: #E63633;">未设置</span>
						<a v-else-if="data.set_ry_count == 0" class="s-link" @click="$refs.person.open(data.id)">立即设置</a>
						<span v-else>已设置</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="已购买保单"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.bx_count == 0" style="color: #E63633;">未购买</span>
						<span v-else>{{data.bx_count}}份</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="140"
					limit="2"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo('/transact/project/detail', {id: data.id}, true)">详情</c-table-button>
						<c-table-button v-if="data.jldw_name && data.set_ry_count == 0" @click="$refs.person.open(data.id)">设置项目人员</c-table-button>
						<c-table-button v-else-if="data.jldw_name" @click="navigateTo('/transact/person_change/apply', {projectId: data.id}, true)">申请项目人员变更</c-table-button>
						<c-table-button v-if="data.zb_path" @click="downloadHandle(data)">下载中标通知书</c-table-button>
						<c-table-button v-if="data.jldw_name" @click="unbindHandle(data)">解绑监理关系</c-table-button>
						<c-table-button v-else @click="copyCode(data)">项目邀请码</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
		
		<install-person ref="person" @resolve="$refs.table.update()"></install-person>
	</app>
</template>

<script>
	import installPerson from './install_person.vue'
	
	export default {
		components: {
			installPerson
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList() {
				this.$refs.table.load({
					url: '/project/list'
				});
			},
			
			downloadHandle(data) {
				window.open(data.zb_path);
			},
			
			unbindHandle(data) {
				this.$confirm({
					text: '确定要解绑监理关系吗？',
					message: `解除绑定后，监理单位（${data.jldw_name}）将无法审批或监理此项目`,
					resolve: () => {
						this.request({
							url: '/project/clear_jl',
							data: {
								project_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '解绑成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			copyCode(data) {
				this.request({
					url: '/project/yq_code',
					data: {
						project_id: data.id,
						type: 1
					},
					loading: true,
					success: data => {
						this.clipboard(data, false);
						this.$confirm({
							icon: 'message',
							text: '项目邀请码已复制',
							message: `此项目的邀请码为：<span style="color: #E63633;">${data}</span>，已复制到内存，你可以直接粘贴发送给相关监理单位。`,
							cancelButton: false
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
